import * as React from 'react';
import {Route, Switch, useHistory, useLocation, useRouteMatch} from 'react-router';
import './container.css';
import Navigation from "../../Components/Navigation";
import {Link} from "react-router-dom";
import {APP_ACTION_ITEMS, APP_LANDING, APP_LOGIN_PATH, APP_LOGOUT_PATH} from "../../types";
import {useEffect, useState} from "react";
import {currentSession} from "../../Auth";
import {getUserProfile} from "../../api";
import ManageClients from "../../Components/ManageClients";
import ManageTherapySessions from "../../Components/ManageTherapySessions";
import ManageUsers from "../../Components/ManageUsers";
import ManageTemplates from "../../Components/ManageTemplates";


const PrivateMainContainer: React.FunctionComponent = () => {

    let {path} = useRouteMatch();
    let location = useLocation();
    let breadcrumbs: String[] = [];
    let fullPath = location.pathname;
    if (fullPath.startsWith("/m")) {
        breadcrumbs = fullPath.replace("/m/", "").split("/");
    }

    const history = useHistory();

    const [validToken, setValidToken] = useState(false);
    const [doLoginRedirect, setDoLoginRedirect] = useState(false);
    const [doActionItemRedirect, setDoActionItemRedirect] = useState(false);

    const getUser = () => {
        getUserProfile()
            .then(user => {
                if (user.actions && user.actions?.length > 0) {
                    setDoActionItemRedirect(true);
                }
            })
            .catch(e => console.log(e));
    }

    useEffect(() => {
        if (doActionItemRedirect) {
            history.push({
                pathname: APP_ACTION_ITEMS
            });
        }
    }, [doActionItemRedirect, history]);

    useEffect(() => {
        currentSession().then(session => {
            setValidToken(true);
            getUser();
        }).catch(e => setDoLoginRedirect(true))
    }, [fullPath, history]);

    useEffect(() => {
        if (doLoginRedirect) {
            history.push({
                pathname: APP_LOGIN_PATH
            });
        }
    }, [doLoginRedirect, history]);

    return validToken ? (
        <>
            <nav className="navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-0 shadow">

                <Link className="navbar-brand col-md-3 col-lg-2 mr-0 px-3"
                      to={APP_LANDING}>
                    PROMISES12
                </Link>

                <button className="navbar-toggler position-absolute d-md-none collapsed" type="button"
                        data-toggle="collapse" data-target="#sidebarMenu" aria-controls="sidebarMenu"
                        aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <input className="form-control form-control-dark w-100" type="text" placeholder="Search"
                       aria-label="Search"/>
                <ul className="navbar-nav px-3">
                    <li className="nav-item text-nowrap">
                        <Link className="nav-link" to={APP_LOGOUT_PATH}>Sign out</Link>
                    </li>
                </ul>
            </nav>

            <div className="container-fluid">
                <div className="row">
                    <Navigation/>

                    <main role="main" className="col-md-9 ml-sm-auto col-lg-10 px-md-4">

                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li key={"bc-home"} className="breadcrumb-item"><Link to={"/"}>Home</Link></li>
                                {
                                    breadcrumbs.map(b => (
                                        <li key={"bc-" + b} className="breadcrumb-item"><Link to={"/"}>{b}</Link></li>
                                    ))
                                }
                            </ol>
                        </nav>
                        <div
                            className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">


                        </div>
                        <Switch>

                            <Route path={path + "/clients"}>
                                <ManageClients />
                            </Route>

                            <Route path={path + "/therapy-sessions"}>
                                <ManageTherapySessions />
                            </Route>

                            <Route path={path + "/users"}>
                                <ManageUsers />
                            </Route>

                            <Route path={path + "/templates"}>
                                <ManageTemplates />
                            </Route>

                        </Switch>

                    </main>
                </div>
            </div>
        </>
    ) : (<></>);

}

export default PrivateMainContainer;